import { render, staticRenderFns } from "./PosHistoryPopup.vue?vue&type=template&id=09d35b18&scoped=true&"
import script from "./PosHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./PosHistoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./PosHistoryPopup.vue?vue&type=style&index=0&id=09d35b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d35b18",
  null
  
)

export default component.exports